var NAMESPACE = 'td';

var Button = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('button', _vm._g({ staticClass: "td-button", class: { 'td-button--secondary': _vm.secondary, 'td-button--other': _vm.other, 'is-disabled': _vm.disabled, 'td-button--warning': _vm.warning, 'td-button--danger': _vm.danger, 'is-status': _vm.status, 'td-button--small': _vm.size === 'small', 'td-button--large': _vm.size === 'large' }, attrs: { "disabled": _vm.disabled } }, _vm.$listeners), [_vm.status && _vm.statusIcon ? _c('td-icon', { attrs: { "type": _vm.statusIcon } }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
  }, staticRenderFns: [],
  name: NAMESPACE + '-button',

  props: {
    secondary: Boolean,
    other: Boolean,
    disabled: Boolean,
    danger: Boolean,
    warning: Boolean,
    size: String,
    status: Boolean,
    statusIcon: String
  }
};

/* istanbul ignore next */
Button.install = function (Vue) {
  Vue.component(Button.name, Button);
};

export default Button;
